import { useEffect, useState } from "react";

import { Box, Button } from "@mui/material";
import api from "../../api";

function StatusActions({ table, payload }) {
    const [inLibrary, setInLibrary] = useState(null);
    const [published, setPublished] = useState(null);
    const [loading, setLoading] = useState(false);

    const checkIfPublished = async () => {
        const items = await api.getJunctionItems(table, {
            filter: {
                _and: [payload]
            }
        });

        return items?.length > 0;
    }

    const addToLibrary = async () => {
        
    }

    const removeFromLibrary = async () => {
        
    }

    useEffect(() => {
        const initialise = async () => {
            setPublished(await checkIfPublished());
        };

        initialise();
    }, [inLibrary]);

    return (
        <Box>
            {
                published &&
                <>
                    <Button
                        disabled={loading}
                        onClick={() => { addToLibrary() }}
                        variant="outlined"
                        sx={{
                            color: '#000',
                            background: '#efeeee',
                            borderColor: '#e0e0e0',
                            width: '100%',
                            fontSize: `0.75rem`,
                            fontWeight: 'bold'
                        }}
                    >
                        Unpublish
                    </Button>
                </>
            }

            {
                !!!published &&
                <>
                    <Button
                        disabled={loading}
                        onClick={() => { removeFromLibrary() }}
                        variant="outlined"
                        sx={{
                            color: '#000',
                            background: '#efeeee',
                            borderColor: '#e0e0e0',
                            width: '100%',
                            fontSize: `0.75rem`,
                            fontWeight: 'bold'
                        }}
                    >
                        Publish
                    </Button>
                </>
            }
        </Box>
    )
}

export default StatusActions